const ALIGNMENT_MAP = {
  'Left Aligned': 'flex-start',
  'Centered Aligned': 'center',
  'Center Aligned': 'center',
  'Right Aligned': 'flex-end',
};

const VIEW_ALL = 'View All';

const DEFAULT_SUB_CATEGORY_FILTER = {
  id: 'all',
  category: VIEW_ALL,
  subCategory: VIEW_ALL,
  url: '/',
};

const LEARN_URL = '/learn';
const NEWSROOM_URL = '/newsroom';

const PAGE_TYPE = {
  CAMPAIGN: 'campaign',
};

const NEW_USER = 'new';
const RETURN_USER = 'return';
const AUTH_USER = 'authorized';

export const VISITOR_STATUS = {
  NEW_USER,
  RETURN_USER,
  AUTH_USER,
};

export const ANALYTICS_VISITOR_STATUS = {
  [NEW_USER]: 'new_user',
  [RETURN_USER]: 'return_user',
  [AUTH_USER]: 'authenticated_user',
};

export const TASTYWORKS_API = process.env.TASTYWORKS_API || 'https://api.tastyworks.com/';
export const LOGIN_AUTHENTICATOR = 'authenticator:twucs';
export const LOGIN_COOKIE_DOMAIN = '.tastytrade.com';
export const LOGIN_COOKIE_KEY = 'ember_simple_auth-session';
export const LOGIN_SUCCESS_URL = process.env.LOGIN_SUCCESS_URL || 'https://manage.tastytrade.com/index.html';

export { ALIGNMENT_MAP, VIEW_ALL, DEFAULT_SUB_CATEGORY_FILTER, LEARN_URL, NEWSROOM_URL, PAGE_TYPE };
